import { Form } from 'factorial-form'

class EmployeeUser extends Form {
  constructor(values: {}) {
    super(values, {
      avatar: 'file',
      avatar_full: 'file',
      first_name: 'string',
      last_name: 'string',
      communications_email: 'string',
      remove_avatar: 'boolean',
      unconfirmed_communications_email: 'string',
      all_tenants: 'boolean',
    })
  }
}

export default EmployeeUser
